import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-zero-balance-modal',
  templateUrl: './zero-balance-modal.component.html',
  styleUrls: ['./zero-balance-modal.component.scss']
})
export class ZeroBalanceModalComponent implements OnInit {

  zeroBalanceModalOptions: ModalOptions;
  hideModal: boolean;
  isAcmic:boolean;
  @Input() policy: any;
  @Output() closeZeroBalanceModal: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private acmicService:AcmicService
  ) { 
    this.hideModal = false;
  }

  hideModalAction(): void {
    this.hideModal = !this.hideModal;
    this.closeZeroBalanceModal.emit(true);
  }

  hideOnClick(event): void {
    if (!event.target.closest(".modal-body")) {
      this.hideModalAction();
    }
  }

  ngOnInit(): void {
    this.isAcmic=this.acmicService.isACMIC();
    this.zeroBalanceModalOptions = new ModalOptions({
      additionalClasses: 'modal-medium modal-dialog center-on-page',
      modalId: 'zeroBalanceModal',
      typeOfModal: 'default',
      modalName: 'zero_balance_modal',
      onLoad: true,
      animatePosition: 'top'
    }); 
  }

}
